var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7441 15.6405C16.0695 15.3151 16.0695 14.7874 15.7441 14.462L9.28204 7.99986L15.7441 1.53793C16.0695 1.2125 16.0695 0.684864 15.7441 0.359429L15.6405 0.255891C15.3151 -0.0695435 14.7875 -0.069544 14.462 0.25589L8 6.7178L1.53808 0.255798C1.21264 -0.0696411 0.685006 -0.0696408 0.359571 0.255798L0.256032 0.359339C-0.0694024 0.684778 -0.0694029 1.21242 0.256032 1.53786L6.71794 7.99984L0.255798 14.4619C-0.0696413 14.7873 -0.0696411 15.3149 0.255799 15.6404L0.359339 15.7439C0.684779 16.0693 1.21242 16.0693 1.53786 15.7439L7.99998 9.2819L14.462 15.7441C14.7875 16.0695 15.3151 16.0695 15.6406 15.7441L15.7441 15.6405Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.fdc809f3e2632b3b74122093b37b8441.svg";
export { ForwardRef as ReactComponent };